import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_hdr_RowClass} from '../../../dbschema';

export class ThemeHeaderContainerModel extends BaseContainerModel {

  bl_cms_theme_hdr: bl_cms_theme_hdr_RowClass = new bl_cms_theme_hdr_RowClass();
}
